/**
 * Utility functions and session storage management
 */

// Storage utility for local storage similar to reactLocalStorage
const storage = {
  get: function (key) {
    const value = localStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  },

  set: function (key, value) {
    if (typeof value === "object") {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  },

  clear: function () {
    localStorage.clear();
  },
};

// Map function (same as p5 map function but available outside of the sketch)
function mapValue(value, x1, y1, x2, y2) {
  return ((value - x1) * (y2 - x2)) / (y1 - x1) + x2;
}

// Initialize the session
function initSession() {
  let userHash;

  if (storage.get("v_usr")) {
    userHash = storage.get("v_usr");
  } else {
    // const session = randomString({ length: 10 });
    const session = generateDeviceFingerprint();
    storage.set("v_usr", session);
    userHash = session;
  }

  return userHash;
}

// Generate a simple device fingerprint
function generateDeviceFingerprint() {
  const components = [
    navigator.userAgent,
    navigator.language,
    `${screen.width}x${screen.height}`,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency,
    navigator.deviceMemory || "unknown",
    navigator.platform,
  ];

  // Simple hash function
  let hash = 0;
  const str = components.join("|");
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }

  // Return as positive hex string
  return Math.abs(hash).toString(16);
}

// Implement randomString function
function randomString(options) {
  const chars =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const length = options && options.length ? options.length : 10;
  let result = "";

  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
}

// Configuration for constants - aligned with shader parameters
const config = {
  // Global parameters
  uv: {
    min: 0.1,
    max: 100.0,
    default: 37.25,
  },
  amplitude: {
    min: 0.0,
    max: 1.0,
    default: 0.1821953,
  },
  hvalue: {
    min: 0.0,
    max: 1.0,
    default: 0.062140625,
  },
  speed: {
    min: 0.0,
    max: 2.5,
    default: 0.13751952,
  },

  // Layer settings
  scale: {
    // User count scaling
    user_max: 100, // Max number of users for scaling
    // Layer 1 scale
    l1_min: 0.26, // Matches L1Scale default
    l1_max: 15.0, // From GUI max
    // Layer 2 scale
    l2_min: 0.5,
    l2_max: 30.0,
  },

  turbulence: {
    // Layer 1 turbulence
    t1_min: 0.0, // Matches L1Turbulance default
    t1_max: 15.0, // From GUI max
    // Layer 2 turbulence
    t2_min: 0.005,
    t2_max: 15.0, // Adjusted to match GUI max
  },

  // Animation parameters
  animation: {
    speed_increment: 0.05, // How fast the speed changes during lerping
    l1_increment: 0.1, // How fast layer 1 scale changes
    l2_increment: 0.05, // How fast layer 2 scale changes
    //   speed_increment: 0.005, // How fast the speed changes during lerping
    //   l1_increment: 0.0001, // How fast layer 1 scale changes
    //   l2_increment: 0.00005, // How fast layer 2 scale changes
    //   t1_increment: 0.2, // How fast layer 1 turbulence changes
    //   t2_increment: 0.1, // How fast layer 2 turbulence changes
    t1_increment: 0.6, // How fast layer 1 turbulence changes
    t2_increment: 0.5, // How fast layer 2 turbulence changes
  },

  // Socket.IO configuration
  socket: {
    project_id: 2,
    channel: "soft_presence",
  },
};

// Get the server URL based on environment
function getServerUrl() {
  const localHosts = ["localhost", "127.0.0.1"];
  const isLocal = localHosts.includes(window.location.hostname);

  // return isLocal ? "http://localhost:8080" : "https://sjs-data-network.fly.dev";
  return isLocal ? "http://localhost:8080" : "https://data.jordanshaw.com";
}
